import React from 'react';
import { Skeleton } from 'components/ui/skeleton';

const EventDetailSkeleton = () => (
    <div
        className="mx-auto box-border w-full max-w-[1280px] px-4 py-2 pb-24 sm:px-[15px] sm:py-4 md:py-6"
        aria-busy="true"
        aria-label="Loading"
    >
        <Skeleton className="mb-6 h-4 w-40" />
        <Skeleton className="mb-6 aspect-video w-full rounded-2xl md:mb-8 md:rounded-3xl" />
        <Skeleton className="mb-3 h-8 w-2/3" />
        <Skeleton className="mb-8 h-4 w-1/3" />
        <div className="space-y-3 rounded-2xl border border-border p-[15px]">
            <Skeleton className="h-4 w-1/2" />
            <Skeleton className="h-4 w-2/5" />
            <Skeleton className="h-10 w-40" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-4/5" />
        </div>
    </div>
);

export default EventDetailSkeleton;
